/* 
  This page is shown when the login request is sent from OSD and user is successfully authorized.
  When user press the "open in desktop app", a special protocol will be open with two params: app_auth_id and authCode
  app_auth_id is for OSD to make sure the auth request is authenticated
  authCode (keycloak refresh token) is sent for OWD can update token internally
*/
import { Button, H2, Grid } from '@ouster/webviz-react-components';

import { useLocation } from 'react-router-dom';

import { useKeycloak } from '../../KeycloakContext';
import { useStoreState } from '../../reducers';

const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export default function AuthRedirect() {
  const { user } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const { keycloak } = useKeycloak();
  const location = useLocation();

  const notifyApp = () => {
    const params = new URLSearchParams(location.search);
    const appAuthId = params.get('app_auth_id');

    const authCode = keycloak?.refreshToken;

    const appAuthProtocol = sessionStorage.getItem('appAuthProtocol');

    if (appAuthId && authCode) {
      /* 
        Safari doesn't allow call http from https.
        Hence, for safari browser, we will use custom portal to send auth code
      */
      if (appAuthProtocol === 'port' && !isSafari()) {
        /* 
          OSD will indicate the the protocol for sending auth code, it is implemented since release 5. OSW will send a request to a special port which OSD listens 
        */
        const url = `http://localhost:54321/auth?app_auth_id=${appAuthId}&code=${authCode}`;
        fetch(url, {
          method: 'GET',
        })
          .then((response) => {
            if (response.ok) {
              console.log('Auth success sent to localhost');
            } else {
              console.error(
                'Error in sending auth request:',
                response.statusText
              );
            }
          })
          .catch((error) => {
            console.error('Fetch error:', error);
          });
      } else {
        /* 
          Backward support, in previous osd, we send auth using custom protocol.
        */
        window.location.href = `osd://auth?app_auth_id=${appAuthId}&code=${authCode}`;
      }

      sessionStorage.removeItem('appAuthProtocol');
      sessionStorage.removeItem('appAuthId');
    }
  };

  if (!user) return null;
  return (
    <Grid placeContent="center" rowGap="2rem" h="100%" minW={400}>
      <H2 textAlign="center">
        Log in as
        <br />
        {user?.email}
      </H2>
      <Button onClick={notifyApp}>Open in desktop app</Button>
    </Grid>
  );
}
